export default '2.25.0';
